module.exports = "/images/calendar.svg?1bde56e5795ffd332d1f4d1a84c71a98";